import React from 'react';
import { StyleSheet, View } from 'react-native';
import { COLORS, ELEVATIONS, RADIUS, SPACING } from '@sweetgreen/garnish';

import { LoadingAnimation } from '@order/components';

export const LoadingResults = () => {
  return (
    <View style={styles.wrapper} testID="location-loading-results">
      <LoadingAnimation size="small" />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    alignItems: 'center',
    backgroundColor: COLORS.OATMEAL,
    borderTopLeftRadius: RADIUS.medium,
    borderTopRightRadius: RADIUS.medium,
    paddingBottom: SPACING.small,
    ...ELEVATIONS['24'],
  },
});
